import React from "react"; 
import { Link } from "react-router-dom";
import waterMark from "../images/watermark.png";
const Footer: React.FC = () => {
  return (
    <footer className="bg-[#F4F6F9] w-full border-t border-[#e7e7e7] py-10 relative">
      <div className="px-10 mx-auto w-full relative z-10">
        <div className="flex flex-wrap justify-between w-full text-sm">
          <div className="flex-1 max-w-[60%] mr-5 text-left pl-0">
            <div className="mb-5">
              <Link to="/">
                <img
                  src="/logo/logo.svg"
                  alt="Takagi Seiko Logo"
                  className="h-auto w-auto max-h-[60px] object-contain [image-rendering:crisp-edges] cursor-pointer"
                />
              </Link>
            </div>
            <div>
              <p className="my-[5px] text-[#555] text-sm leading-[1.5]">
                <b>Managing agency:</b> Takagi Seiko Co., Ltd
              </p>
              <p className="my-[5px] text-[#555] text-sm leading-[1.5]">
                <b>Address:</b> 330-2 Iwafune, Nakano-shi, Nagano Prefecture,
                383-8585 Japan
              </p>
              <p className="my-[5px] text-[#555] text-sm leading-[1.5]">
                <b>Email:</b> software.support@takagi-j.com
              </p>
            </div>
          </div>

          <div className="flex flex-col items-end flex-1 max-w-[50%] pr-0 text-right">
            <div className="mb-5 w-full text-right">
              <a
                href="https://www.takagi-global.com/en/terms-conditions/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0066cc] underline mx-[5px] hover:underline"
              >
                Terms & Conditions
              </a>{" "}
              |
              <a
                href="https://www.takagi-global.com/en/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0066cc] underline mx-[5px] hover:underline"
              >
                Privacy Policy
              </a>{" "}
              |
              <a
                href="https://www.takagi-global.com/en/cookie-declaration/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0066cc] underline ml-[5px] mr-0 hover:underline"
              >
                Cookie Declaration
              </a>
            </div>
            <div className="text-right">
              <p className="my-[5px] text-[#666] text-sm">
                <b>©2025 Takagi Seiko Co., Ltd. | All Rights Reserved.</b>
              </p>
              <p className="my-[5px] text-[#666] text-sm">
                <b>
                  No content from takagi-j.com may be copied, used, or
                  redistributed.
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-fit absolute bottom-3 right-4">
        <img src={waterMark} alt="WaterMark" />
      </div>
    </footer>
  );
};

export default Footer;
